import { createReducer } from '@reduxjs/toolkit';
import { set_discount_code } from '../confg';

const initialDiscountCodeState = '';
// const initialDiscountCodeState = localStorage.getItem('discountCode') || '';

const discountCode = createReducer(initialDiscountCodeState, {
  [set_discount_code]: (state, action) => {
    const newDiscountCode = action.payload;
    // localStorage.setItem('discountCode', newDiscountCode);
    return newDiscountCode;
  }
});

export default discountCode;
